var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61263",
    "data-name": "Group 61263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.191,
    height: 40.611,
    viewBox: "0 0 118.191 40.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22608",
    "data-name": "Rectangle 22608",
    width: 118.191,
    height: 40.611,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82260",
    "data-name": "Path 82260",
    d: "M148.772,103.63h-3.617V85.178h11.659v3.409h-8.068v4.554h7.183v3.305h-7.157Z",
    transform: "translate(-107.925 -63.331)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61258",
    "data-name": "Group 61258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61257",
    "data-name": "Group 61257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82261",
    "data-name": "Path 82261",
    d: "M200.35,84.6a2.1,2.1,0,0,1,.625-1.523,2.036,2.036,0,0,1,1.509-.638,2.058,2.058,0,0,1,1.51.625,2.089,2.089,0,0,1,.625,1.536,2.028,2.028,0,0,1-.625,1.483,2.137,2.137,0,0,1-3.019,0,2.026,2.026,0,0,1-.625-1.483m3.877,16.994h-3.461v-12.8h3.461Z",
    transform: "translate(-148.963 -61.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82262",
    "data-name": "Path 82262",
    d: "M234.353,111.655v7.365h-3.461v-12.8h3.357V107.8a3.57,3.57,0,0,1,1.562-1.431,4.81,4.81,0,0,1,2.133-.495,4.239,4.239,0,0,1,3.449,1.418,5.516,5.516,0,0,1,1.184,3.656v8.068h-3.461v-7.469a2.793,2.793,0,0,0-.585-1.847,2.5,2.5,0,0,0-3.526.052,2.805,2.805,0,0,0-.651,1.9",
    transform: "translate(-171.671 -78.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82263",
    "data-name": "Path 82263",
    d: "M300.576,83.656v16.526q0,1.275.1,2.316h-3.305a7.61,7.61,0,0,1-.13-1.483,3.228,3.228,0,0,1-1.393,1.3,4.7,4.7,0,0,1-2.2.495,5.826,5.826,0,0,1-4.49-1.913,7.466,7.466,0,0,1-.026-9.59,5.669,5.669,0,0,1,4.411-1.926q2.758,0,3.618,1.588V83.656ZM290.9,96.069a3.822,3.822,0,0,0,.885,2.668,2.948,2.948,0,0,0,2.29.976,2.9,2.9,0,0,0,2.265-.989,3.874,3.874,0,0,0,.884-2.681,3.69,3.69,0,0,0-.884-2.615,3.174,3.174,0,0,0-4.542.013,3.7,3.7,0,0,0-.9,2.628",
    transform: "translate(-213.691 -62.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82264",
    "data-name": "Path 82264",
    d: "M353.757,143.407a2.357,2.357,0,0,1,0-3.357,2.3,2.3,0,0,1,1.666-.69,2.329,2.329,0,0,1,1.692.69,2.356,2.356,0,0,1,0,3.357,2.329,2.329,0,0,1-1.692.689,2.3,2.3,0,0,1-1.666-.689",
    transform: "translate(-262.501 -103.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82265",
    "data-name": "Path 82265",
    d: "M384.709,84.6a2.1,2.1,0,0,1,.625-1.523,2.036,2.036,0,0,1,1.509-.638,2.057,2.057,0,0,1,1.509.625,2.089,2.089,0,0,1,.625,1.536,2.028,2.028,0,0,1-.625,1.483,2.136,2.136,0,0,1-3.019,0,2.026,2.026,0,0,1-.625-1.483m3.877,16.994h-3.461v-12.8h3.461Z",
    transform: "translate(-286.036 -61.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82266",
    "data-name": "Path 82266",
    d: "M418.712,111.655v7.365h-3.461v-12.8h3.357V107.8a3.57,3.57,0,0,1,1.562-1.431,4.809,4.809,0,0,1,2.133-.495,4.239,4.239,0,0,1,3.449,1.418,5.516,5.516,0,0,1,1.184,3.656v8.068h-3.461v-7.469a2.793,2.793,0,0,0-.585-1.847,2.5,2.5,0,0,0-3.526.052,2.805,2.805,0,0,0-.651,1.9",
    transform: "translate(-308.744 -78.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82267",
    "data-name": "Path 82267",
    d: "M152.051,13.025h-3.305v6.949h-3.591V1.522h6.9a6.064,6.064,0,0,1,4.385,1.613,5.488,5.488,0,0,1,1.679,4.138,5.486,5.486,0,0,1-1.679,4.138,6.061,6.061,0,0,1-4.385,1.614m-3.279-3.1h2.837a3,3,0,0,0,2.108-.716A2.469,2.469,0,0,0,154.5,7.3a2.524,2.524,0,0,0-.768-1.939,2.991,2.991,0,0,0-2.121-.716h-2.837Z",
    transform: "translate(-107.924 -1.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82268",
    "data-name": "Path 82268",
    d: "M209.394,11.321v7.521h-3.461V0h3.461V7.1A4.249,4.249,0,0,1,212.855,5.7a4.413,4.413,0,0,1,3.553,1.418,5.438,5.438,0,0,1,1.21,3.656v8.068h-3.461V11.373a2.793,2.793,0,0,0-.585-1.848,2.514,2.514,0,0,0-3.487,0,2.775,2.775,0,0,0-.69,1.8",
    transform: "translate(-153.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82269",
    "data-name": "Path 82269",
    d: "M264.359,23.943a6.948,6.948,0,0,1,9.6,0,6.62,6.62,0,0,1,1.913,4.867,6.618,6.618,0,0,1-1.913,4.867,6.948,6.948,0,0,1-9.6,0,6.62,6.62,0,0,1-1.913-4.867,6.622,6.622,0,0,1,1.913-4.867m2.5,7.547a3.236,3.236,0,0,0,4.607,0,3.653,3.653,0,0,0,.95-2.681,3.655,3.655,0,0,0-.95-2.681,3.236,3.236,0,0,0-4.607,0,3.652,3.652,0,0,0-.95,2.681,3.651,3.651,0,0,0,.95,2.681",
    transform: "translate(-195.132 -16.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82270",
    "data-name": "Path 82270",
    d: "M326.235,8.625v3.826h2.576v3.071h-2.576v5.361a1.51,1.51,0,0,0,.364,1.145,1.644,1.644,0,0,0,1.145.338,4.126,4.126,0,0,0,1.067-.1v2.863a5.161,5.161,0,0,1-1.952.312,4.094,4.094,0,0,1-2.967-1.054,3.843,3.843,0,0,1-1.093-2.9V15.521h-2.316V12.451h.65a1.885,1.885,0,0,0,1.471-.559,2.1,2.1,0,0,0,.507-1.47v-1.8Z",
    transform: "translate(-238.284 -6.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82271",
    "data-name": "Path 82271",
    d: "M363.084,23.943a6.948,6.948,0,0,1,9.6,0A6.62,6.62,0,0,1,374.6,28.81a6.618,6.618,0,0,1-1.913,4.867,6.948,6.948,0,0,1-9.6,0,6.62,6.62,0,0,1-1.913-4.867,6.622,6.622,0,0,1,1.913-4.867m2.5,7.547a3.236,3.236,0,0,0,4.607,0,3.653,3.653,0,0,0,.95-2.681,3.655,3.655,0,0,0-.95-2.681,3.236,3.236,0,0,0-4.607,0,3.652,3.652,0,0,0-.95,2.681,3.651,3.651,0,0,0,.95,2.681",
    transform: "translate(-268.535 -16.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82272",
    "data-name": "Path 82272",
    d: "M26.671,11.643v2.493H15.662a2.3,2.3,0,0,0-2.3,2.3v11.04H0V11.643A10.874,10.874,0,0,1,10.874.769H15.8A10.874,10.874,0,0,1,26.671,11.643",
    transform: "translate(0 -0.572)",
    fill: "#6711ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82273",
    "data-name": "Path 82273",
    d: "M13.367,104.876v2.43A10.874,10.874,0,0,1,2.493,118.18H0v-13.3Z",
    transform: "translate(0 -77.977)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82274",
    "data-name": "Path 82274",
    d: "M65.419,52.883v2.43A10.874,10.874,0,0,1,54.545,66.187h-2.43V55.179a2.3,2.3,0,0,1,2.3-2.3Z",
    transform: "translate(-38.748 -39.319)",
    fill: "#00eaaf"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.55cfdda27e54d89074cad13bf9361abd.svg";
export { ForwardRef as ReactComponent };